import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useProducer } from "../context/ProducerContext";
import { registerCustomer } from "../api/authApi";

export default function SignupPage() {
  const { slug } = useParams();
  const navigate = useNavigate();

  const { producer } = useProducer()
  console.log("producer in signup",producer)

  const [form, setForm] = useState({
    username: "",
    password: "",
    customerName: "",
    phoneNumber: "",
    email: "",
    address: "",
    pincode: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const validate = () => {
    let temp = {};

    if (!form.username.trim()) temp.username = "Username is required";
    if (!form.customerName.trim()) temp.customerName = "Full name is required";

    if (!/^\d{10}$/.test(form.phoneNumber))
      temp.phoneNumber = "Enter a valid 10-digit phone number";

    if (!/\S+@\S+\.\S+/.test(form.email))
      temp.email = "Enter a valid email address";

    if (form.password.length < 8)
      temp.password = "Password must be at least 8 characters";

    if (!/^\d{6}$/.test(form.pincode))
      temp.pincode = "Pincode must be 6 digits";

    if (!form.address.trim()) temp.address = "Address is required";

    setErrors(temp);
    return Object.keys(temp).length === 0;
  };

  const handleSubmit = () => {
    if (!validate()) return;

    const payload = {
      producerId: producer?.id,
      ...form,
    };

    registerCustomer(payload)
      .then(() => {
        alert("Signup successful!");
        navigate(`/${slug}`);
      })
      .catch(() => alert("Signup failed"));
  };

  return (
    <div className="min-h-screen flex justify-center items-center bg-gray-100 py-10 px-4">
      <div className="bg-white p-6 rounded-xl shadow-md w-full max-w-lg">
        <h2 className="text-2xl font-bold mb-6 text-center">
          Create Account – {producer?.name}
        </h2>

        {/* Username */}

        {/* Full Name */}
        <div className="mb-4">
          <label className="block font-medium mb-1">Full Name</label>
          <input
            type="text"
            name="customerName"
            value={form.customerName}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          />
          {errors.customerName && (
            <p className="text-red-500 text-sm">{errors.customerName}</p>
          )}
        </div>

        {/* Phone Number */}
        <div className="mb-4">
          <label className="block font-medium mb-1">Phone Number</label>
          <input
            type="text"
            name="phoneNumber"
            value={form.phoneNumber}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          />
          {errors.phoneNumber && (
            <p className="text-red-500 text-sm">{errors.phoneNumber}</p>
          )}
        </div>

        {/* Email */}
        <div className="mb-4">
          <label className="block font-medium mb-1">Email</label>
          <input
            type="text"
            name="email"
            value={form.email}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          />
          {errors.email && (
            <p className="text-red-500 text-sm">{errors.email}</p>
          )}
        </div>

        <div className="mb-4">
          <label className="block font-medium mb-1">Username</label>
          <input
            type="text"
            name="username"
            value={form.username}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          />
          {errors.username && (
            <p className="text-red-500 text-sm">{errors.username}</p>
          )}
        </div>


        {/* Password */}
        <div className="mb-4">
          <label className="block font-medium mb-1">Password</label>
          <input
            type="password"
            name="password"
            value={form.password}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          />
          {errors.password && (
            <p className="text-red-500 text-sm">{errors.password}</p>
          )}
        </div>

        {/* Address */}
        <div className="mb-4">
          <label className="block font-medium mb-1">Address</label>
          <textarea
            name="address"
            value={form.address}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded h-20"
          ></textarea>
          {errors.address && (
            <p className="text-red-500 text-sm">{errors.address}</p>
          )}
        </div>

        {/* Pincode */}
        <div className="mb-4">
          <label className="block font-medium mb-1">Pincode</label>
          <input
            type="text"
            name="pincode"
            value={form.pincode}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          />
          {errors.pincode && (
            <p className="text-red-500 text-sm">{errors.pincode}</p>
          )}
        </div>

        <button
          onClick={handleSubmit}
          className="w-full bg-blue-600 text-white py-2 rounded-lg mt-4 hover:bg-blue-700 transition"
        >
          Sign Up
        </button>
      </div>
    </div>
  );
}
